export default __webpack_public_path__ + "static/planet1-xs-55cc923681b59852096cf98c04c0e3aa.png";